import { signal, Service } from '@angular/core';

/**
 * A service to be used with the base-layout component to provide child views with an ability
 * to specify that an app's content container should not stretch beyond 100% of the screen height
 */
@Service()
export class LayoutService {
  readonly vh100ContentSection = signal(false);

  set vhFullContentSection(isFullHeight: boolean) {
    queueMicrotask(() => this.vh100ContentSection.set(isFullHeight));
  }
}
